import { CoinWinOverlayLandscapeProperties } from "../landscape/CoinWinOverlayLandscapeProperties";
export class CoinWinOverlayPortraitProperties extends CoinWinOverlayLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.collectionSpineProperties.position.set(477, 1417);
        this.collectionSpineProperties.scale.set(1.07);
    }
}
